import type * as MapLibre from 'maplibre-gl';
import { isMapUsable } from '../map-lifecycle';

export const MARKER_IMAGE_PREFIX = 'marker-';

// Starts with MARKER_IMAGE_PREFIX — always test this one first when matching.
export const MARKER_IMAGE_HIGHLIGHTED_PREFIX = 'marker-hl-';

export const MARKER_DOTS_LAYER_ID = 'marker-dots';

export const PIN_INTERACTION_LAYER_IDS = [
    MARKER_DOTS_LAYER_ID,
    'markers',
    'markers-highlighted',
    'selected-marker',
] as const;

export function hasVisiblePinInteractionLayer(map: MapLibre.Map): boolean {
    if (!isMapUsable(map)) {
        return false;
    }

    return PIN_INTERACTION_LAYER_IDS.some(layerId => {
        if (!map.getLayer(layerId)) return false;
        return map.getLayoutProperty(layerId, 'visibility') !== 'none';
    });
}
